import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  DialogTitle,
  Typography,
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { pickerLocaleProps } from '../../Helpers/dates';

const DateRangePicker = function DateRangePicker({
  close = null,
  open = false,
  setPeriodRange = () => {},
  disableMaxDate = false,
  disableMinDate = false,
  periodRange = [null, null],
  title,
}) {
  const intl = useIntl();
  const [startDate, setStartDate] = useState(periodRange[0]);
  const [endDate, setEndDate] = useState(periodRange[1]);

  const handleSetPeriodRange = () => {
    setPeriodRange([startDate, endDate]);
    close();
  };
  const getMinDate = () => {
    if (disableMinDate) return undefined;
    const date = new Date();
    date.setMonth(date.getMonth() - 2);
    date.setDate(1);

    return date;
  };

  useEffect(() => {
    if (open) {
      setStartDate(periodRange[0]);
      setEndDate(periodRange[1]);
    }
  }, [open]);

  return (
    <Dialog onClose={close} open={open} maxWidth="md">
      <DialogTitle sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h6">{intl.messages[title] || title}</Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: 'text.secondary',
          }}
        >
          {intl.messages.SELECT_DATE_RANGE}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', padding: '8px' }}>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          {...pickerLocaleProps}
        >
          <DateCalendar
            minDate={disableMinDate ? undefined : getMinDate()}
            maxDate={disableMaxDate ? undefined : new Date()}
            value={startDate}
            onChange={(newDate) => setStartDate(newDate)}
          />
        </LocalizationProvider>

        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          {...pickerLocaleProps}
        >
          <DateCalendar
            minDate={disableMinDate ? undefined : getMinDate()}
            maxDate={disableMaxDate ? undefined : new Date()}
            value={endDate}
            onChange={(newDate) => setEndDate(newDate)}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Button onClick={close} variant="text">
          {intl.messages.CLOSE}
        </Button>
        <Button onClick={handleSetPeriodRange} variant="contained">
          {intl.messages.CONFIRM}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DateRangePicker;
